import { BaseModel } from '@/models';

export class TiptapConfigState extends BaseModel {
    static entity = 'tiptapConfigState';

    static fields() {
        return {
            ...super.fields(),
            id: this.string(null).nullable(),
            field_id: this.string(null).nullable(),
            field_state: this.string(null).nullable(),
            condition_field_id: this.string(null).nullable(),
            condition_field_value: this.attr(null)
        };
    }

    get is_valid() {
        return [this.field_id, this.field_state, this.condition_field_id, this.condition_field_value !== null].every(
            v => v
        );
    }

    get computed_name() {
        if (this.is_valid) {
            // eslint-disable-next-line max-len
            return `${this.field_id} will be ${this.field_state} if ${this.condition_field_id} is ${this.condition_field_value}`;
        }

        if (this.field_id) {
            return this.field_id;
        }

        return 'Field State';
    }
}

export default TiptapConfigState;
